// @ts-nocheck
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import { ValidateState, chain } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import siteMessage from "@insite/client-framework/SiteMessage";
import { AddressFieldDisplayModel } from "@insite/client-framework/Types/ApiModels";

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

replaceInChain(chain, ValidateState, props => {
    const { country, state } = props.parameter.address;
    const { addressFieldDisplayCollection, validationRules } = props.parameter; // Store Custom Code

    const countries = getCurrentCountries(props.getState());
    if (!countries) {
        throw new Error("Cannot validate country. The website countries have not been loaded yet.");
    }

    if (!country) {
        // This is fine to simply return because the address country
        // is validated in the previous handler. If the country has not
        // been selected yet, it doesn"t make sense to show an error for the state.
        return;
    }

    const countryLookup = countries.find(c => c.id === country.id);

    const stateRules = validationRules.state;

    if (
        countries.length > 0 &&
        countryLookup?.states &&
        countryLookup.states.length > 0 &&
        !state &&
        addressFieldDisplayCollection.state &&
        stateRules?.isRequired && // Store Custom Code
        !stateRules?.isDisabled // Store Custom Code
    ) {
        props.addressErrors.state = getRequiredErrorMessage(addressFieldDisplayCollection.state);
    }
});
